const playingVideos = new Set();
let throttleTimer = null;

function checkVideosInViewport() {
    const videos = document.querySelectorAll('video');
    
    videos.forEach(video => {
        const rect = video.getBoundingClientRect();
        const isPartiallyInViewport = rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
        const isFullyOutside = rect.bottom <= 0 || rect.top >= window.innerHeight || rect.right <= 0 || rect.left >= window.innerWidth;
        
        if (isPartiallyInViewport && !playingVideos.has(video)) {
            video.play().catch(() => {});
            playingVideos.add(video);
            video.classList.add('playing');
        } else if (isFullyOutside && playingVideos.has(video)) {
            video.pause();
            playingVideos.delete(video);
            video.classList.remove('playing');
        }
    });
}

function throttledCheck() {
    if (throttleTimer) return;
    
    throttleTimer = setTimeout(() => {
        checkVideosInViewport();
        throttleTimer = null;
    }, 100);
}

window.addEventListener('scroll', throttledCheck, { passive: true });
window.addEventListener('resize', throttledCheck, { passive: true });

checkVideosInViewport();